module.exports = __webpack_public_path__ + "img/dashboard1.319210a6.png";